module.exports = __webpack_public_path__ + "static/img/fcsv2.a9b85c32.jpg";